require('./depositSelectorRadioButton.scss')
const React = require('react');
import { i18n } from 'core/i18n'
const { FormattedText } = i18n;
const PropTypes = require('prop-types');
const classnames = require('classnames');

const { RadioButton } = require('commonsComponents/radioButton');

class DepositSelectorItem extends React.Component {
    componentDidMount() {
        const { preselected, card, onClick } = this.props;

        preselected && card && onClick(card, true);

    }

    componentDidUpdate(lastProps) {
        const lastPreselected = lastProps.preselected
        const { preselected, card, onClick } = this.props
        !lastPreselected && preselected && card && onClick(card)
    }

    handleOnClick(c) {
        const { onClick } = this.props;

        onClick(c)
    }

    renderButton = () => {
        const { active } = this.props;
        return <RadioButton isChecked={active} />
    }

    render() {
        const { preselected, card, active, isExclusiveOffer } = this.props;
        const { formatedMonths, formatedTae, formatedTin } = card
        const tinElementClass = formatedTae ? 'deposit-selector-radio-button__item__card-info-tin' : 'deposit-selector-radio-button__item__card-info-tin deposit-selector-radio-button__item__card-info-tin--only'
        const buttonsSection = (
            <div className="deposit-selector-radio-button__item__card-info-buttons pull-right">
                {this.renderButton()}
            </div>
        );
        const content = (
            <div className="deposit-selector-radio-button__item__card-info-container">
                <div className='deposit-selector-radio-button__item__months-button'>
                    <span className="deposit-selector-radio-button__item__card-info-months">{formatedMonths}</span>
                    {buttonsSection}
                </div>
                {!!formatedTae && <div className="deposit-selector-radio-button__item__card-info-tae">{formatedTae}</div>}
                <div className={tinElementClass}>{formatedTin}</div>
            </div>
        );
        let depositBoxHeaderView;
        const divClassName = classnames('deposit-selector-radio-button__item',
            {
                'deposit-selector-radio-button__item--active': active,
                'deposit-selector-radio-button__item--alt': isExclusiveOffer,
                'deposit-selector-radio-button__item--active-alt': active && isExclusiveOffer,
            })

        const infoSectionClass = classnames(
            'deposit-selector-radio-button__item__card-info-inner'
        );

        depositBoxHeaderView = (
            <div className={divClassName} onClick={!preselected && (() => this.handleOnClick(card))}>
                {isExclusiveOffer && <div className="deposit-selector-radio-button__tag">
                    <FormattedText value="contractsView-contractsView_depositExclusiveCC" />
                </div>}
                <div className="row">
                    <div className="col-xs-12">
                        <div className="deposit-selector-radio-button__item__card-info">
                            <div className={infoSectionClass}>
                                {content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return depositBoxHeaderView;
    }
}

DepositSelectorItem.propTypes = {
    card: PropTypes.object.isRequired,
    preselected: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func,
}

module.exports.constructor = DepositSelectorItem;
module.exports.DepositSelectorItem = DepositSelectorItem
